module.exports = __webpack_public_path__ + "static/img/1958_09_25_Neue_Rhein_Zeitung.e31b9e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_09_25_Neue_Rhein_Zeitung.jpg
// module id = aVnN
// module chunks = 0